module.exports = __webpack_public_path__ + "static/media/feature.71eda8e6.JPG";